import { fromJS } from 'immutable';

export const updateOrAdd = (obj, idExtractor = (o) => o.get('id')) => (items = fromJS([])) => {
  let found = false;
  const result = items.map(o => {
    if (idExtractor(o) === idExtractor(obj)) {
      console.log('found');
      found = true;
      return obj;
    }

    return o;
  });

  if (!found) {
    return result.push(obj);
  }

  return result;
};

export const remove = (obj, idExtractor = (o) => o.get('id')) => (items = fromJS([])) => items.filter((item) => idExtractor(item) !== idExtractor(obj));

export const updateOrAddMap = (obj, idExtractor = (o) => o.get('id')) => (objects = fromJS({})) => objects.set(idExtractor(obj), obj);

export const removeMap = (obj, idExtractor = (o) => o.get('id')) => (items) => items.delete(idExtractor(obj));



// WEBPACK FOOTER //
// ./src/redux/reducers/helper.js